// extracted by mini-css-extract-plugin
export default {"content":"style_content__hsLYN","padding":"style_padding__FRj43","padding2":"style_padding2__wWbZt","none":"style_none__vFxlg","btn-submit":"style_btn-submit__hGehJ"};